module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.news()
      }
    }
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Contáctenos")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Llámenos al (502) 2478 - 1179 o envíenos sus preguntas o comentarios vía email. Intentaremos responder todas sus preguntas en los siguientes 2 a 3 días hábiles")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_name),
      expression: "contact_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('contact_name')
    },
    attrs: {
      "data-vv-as": "nombre",
      "type": "text",
      "name": "contact_name"
    },
    domProps: {
      "value": (_vm.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_name')),
      expression: "errors.has('contact_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contact_name')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_company),
      expression: "contact_company"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('contact_company')
    },
    attrs: {
      "data-vv-as": "empresa",
      "type": "text",
      "name": "contact_company"
    },
    domProps: {
      "value": (_vm.contact_company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_company = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_company')),
      expression: "errors.has('contact_company')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contact_company')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Correo Electrónico")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_email),
      expression: "contact_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('contact_email')
    },
    attrs: {
      "data-vv-as": "correo electrónico",
      "name": "contact_email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_email')),
      expression: "errors.has('contact_email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contact_email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Número Whatsapp")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_phone),
      expression: "contact_phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('contact_phone')
    },
    attrs: {
      "data-vv-as": "número",
      "name": "contact_phone",
      "type": "contact_phone"
    },
    domProps: {
      "value": (_vm.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_phone')),
      expression: "errors.has('contact_phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contact_phone')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Mensaje")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_message),
      expression: "contact_message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.errors.has('contact_message')
    },
    attrs: {
      "data-vv-as": "mensaje",
      "name": "contact_message"
    },
    domProps: {
      "value": (_vm.contact_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_message')),
      expression: "errors.has('contact_message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contact_message')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("¿Cómo prefiere que lo contactemos?")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_media),
      expression: "contact_media"
    }],
    attrs: {
      "name": "contact_media",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.contact_media, null)
    },
    on: {
      "change": function($event) {
        _vm.contact_media = null
      }
    }
  }), _c('span', [_vm._v(" Correo Electrónico")]), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_media),
      expression: "contact_media"
    }],
    attrs: {
      "name": "contact_media",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.contact_media, null)
    },
    on: {
      "change": function($event) {
        _vm.contact_media = null
      }
    }
  }), _c('span', [_vm._v(" Whatsapp")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label labelClass"
  }, [_vm._v("Manténgase en contacto")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_type),
      expression: "contact_type"
    }],
    attrs: {
      "name": "contact_type",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact_type) ? _vm._i(_vm.contact_type, null) > -1 : (_vm.contact_type)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contact_type,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contact_type = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contact_type = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact_type = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Enviarme información de nuevos productos y promociones en Hipromeasa")])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v("Enviar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d34179c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactComponent.vue
// module id = 78
// module chunks = 0